import { Separator } from "@/shared/components";
import { Children, Fragment, ReactNode } from "react";

type SeparatedProps = {
    children: ReactNode;
    orientation?: "vertical" | "horizontal";
    className?: string;
};

export function Separated({ children, orientation = "horizontal", className = "border-default" }: SeparatedProps) {
    const items = Children.toArray(children);

    return (
        <>
            {items.map((child, index) => (
                <Fragment key={`separated-${index}`}>
                    {child}
                    {index < items.length - 1 && <Separator orientation={orientation} className={className} />}
                </Fragment>
            ))}
        </>
    );
}
